import { Button } from "@wac-ui-dashboard/wac_component_library";
import useAudioBulkUpload from "./useAudioBulkUpload";
import Style from "./audioBulkUpload.module.scss";

const formatSize = (bytes) => {
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
};

const AudioBulkUpload = ({ endpoint, entityLabel = "podcast", refetch, handleClose }) => {
  const {
    fileInputRef,
    items,
    progress,
    isUploading,
    errorMessage,
    acceptTypes,
    handleFileChange,
    handleRemove,
    handleUpload,
    handleCancel,
  } = useAudioBulkUpload({ endpoint, entityLabel, refetch, handleClose });

  return (
    <div>
      <p className="pro-font-sm pro-mb-4">
        Select the audio files. Each file is created as a separate {entityLabel} with the
        file name as its title. Entries are added as inactive with no other details; add them
        from the list once the audio has been processed.
      </p>

      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="audio_bulk_files"
          className={`${Style.drop_zone} ${isUploading ? Style.disabled : ""}`}
        >
          <span className="material-symbols-outlined">audio_file</span>
          <span className="pro-fw-medium">Click to select audio files</span>
          <span className="pro-font-xs pro-opacity-60">MP3 or WAV, up to 20 files</span>
          <input
            type="file"
            multiple
            ref={fileInputRef}
            accept={acceptTypes}
            id="audio_bulk_files"
            className={Style.file_input}
            onChange={handleFileChange}
            disabled={isUploading}
          />
        </label>
      </div>

      {items.length > 0 && (
        <div className={`pro-mb-4 ${Style.list_wrap}`}>
          <table className={Style.list}>
            <thead>
              <tr>
                <th>Title</th>
                <th>Size</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td>
                    <p className={`pro-mb-0 pro-fw-medium ${Style.title}`} title={item.title}>
                      {item.title}
                    </p>
                    <p
                      className={`pro-mb-0 pro-font-xs pro-opacity-60 ${Style.title}`}
                      title={item.name}
                    >
                      {item.name}
                    </p>
                  </td>
                  <td className="pro-font-sm pro-nowrap">{formatSize(item.size)}</td>
                  <td>
                    {!isUploading && (
                      <button
                        type="button"
                        className="pro-btn-link pro-p-0"
                        onClick={() => handleRemove(item.id)}
                        aria-label={`Remove ${item.name}`}
                      >
                        <span className="material-symbols-outlined">close</span>
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {isUploading && (
        <div className={`pro-mb-4 ${Style.progress}`}>
          <span style={{ width: `${progress}%` }} />
          <em>Uploading {progress}%</em>
        </div>
      )}

      {errorMessage && <p className="error-text pro-mb-4">{errorMessage}</p>}

      <div className="col-12 pro-mt-4 pro-d-flex pro-justify-end">
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCancel}
          type="button"
          disabled={isUploading}
        >
          Cancel
        </Button>
        <Button
          className={"pro-btn-primary lg pro-mx-3"}
          type="button"
          onClick={handleUpload}
          disabled={isUploading || items.length === 0}
        >
          {isUploading ? "Uploading..." : `Upload${items.length ? ` (${items.length})` : ""}`}
        </Button>
      </div>
    </div>
  );
};

export default AudioBulkUpload;
